/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

/**
 * This component is used to display a dialog when no user input is needed but rather just as an alert.
 * @param {Boolean} open whether or not the dialog is open.
 * @param {() => onClose} onClose The callback method to be called when the dialog is closed.
 * @param {() => onClose} title The title of the dialog.
 * @param {() => onClose} message The message to be displayed in the dialog.
 */
const MessageDialog = ({ open, onClose, title, message }) => {
	return (
		<Dialog open={open} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description">
			<DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-dialog-description">{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<button className="btn btn-primary" type="button" onClick={onClose} color="primary">
					Ok
				</button>
			</DialogActions>
		</Dialog>
	);
};

MessageDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
};

export default MessageDialog;
